import { render } from "./PurchaseDialog.vue?vue&type=template&id=c1e725be&scoped=true"
import script from "./PurchaseDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseDialog.vue?vue&type=script&lang=js"

import "./PurchaseDialog.vue?vue&type=style&index=0&id=c1e725be&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1e725be"]])

export default __exports__